// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1251":"5de09540","4238":"1589b23c","8747":"3ba78b4c"}[chunkId] + ".chunk.css";
};